import moment from "moment";
import { useEffect, useState } from "react";
import Calendar from "react-awesome-calendar";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { AiFillDollarCircle } from "react-icons/ai";
import { FaCalendarAlt, FaUserTie } from "react-icons/fa";
import { FaBus, FaUserGraduate } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";
import "react-loading-skeleton/dist/skeleton.css";
import ReactPaginate from "react-paginate";
import SkeletonLoading from "../../component/SkeletonLoading";
import i18n from "../../store/api/i18n";
import {
  useGetCalendarSchoolQuery,
  useGetDashboardSchoolQuery,
  useGetDashboardSchoolStatsQuery,
} from "../../store/api/school/dashboardSchoolSlice";
import { formatOfDate } from "../../utils/dateAndTimeConversion";
import ReservationDetail from "./ReservationDetail";

const initialDate = {
  startDate: "",
  endDate: "",
};
const initialPagination = {
  limit: 10,
  page: 1,
  total: 0,
  totalPages: 0,
};

const SchoolDashboard = () => {
  const { t } = useTranslation();
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const [bookingIdData, setBookingIdData] = useState();
  const [dashboardStats, setDashboardStats] = useState({
    monthlyPayments: 0,
    dueMonthlyPayments: 0,
    totalReservedVehicles: 0,
  });
  const [date, setDate] = useState(initialDate);
  const [reservedVehicles, setReservedVehicles] = useState([]);
  const [pagination, setPagination] = useState(initialPagination);
  const [eventsCalender, setEventsCalender] = useState([]);

  // Get Dashboard Stats
  const { data, isSuccess, isLoading, isFetching } =
    useGetDashboardSchoolStatsQuery({
      startDate: date.startDate,
      endDate: date.endDate,
    });

  // Get Reserved Vehicles
  const {
    data: dashboardData,
    isSuccess: isDashboardSuccess,
    isLoading: isDashboardLoading,
    isFetching: isDashboardFetching,
    refetch,
  } = useGetDashboardSchoolQuery({
    ...date,
    page: pagination.page,
    limit: pagination.limit,
    startDate: date.startDate,
    endDate: date.endDate,
  });

  // Get Calendar Events
  const {
    data: calendarData,
    isSuccess: isCalendarSuccess,
    isLoading: isCalendarLoading,
    isFetching: isCalendarFetching,
  } = useGetCalendarSchoolQuery({
    startDate: date.startDate,
    endDate: date.endDate,
  });

  // Fetch Dashboard Stats
  useEffect(() => {
    if (isSuccess && data?.data) {
      setDashboardStats(data.data);
    }
  }, [data, isSuccess]);

  // Fetch Dashboard Reserved Vehicles
  useEffect(() => {
    if (isDashboardSuccess && dashboardData?.data) {
      setReservedVehicles(dashboardData.data.data);
      setPagination((prev) => ({
        ...prev,
        total: dashboardData?.data.pagination.total,
        page: dashboardData?.data.pagination.page,
        limit: dashboardData?.data.pagination.limit,
        totalPages: dashboardData?.data.pagination.pages,
      }));
    }
  }, [dashboardData, isDashboardSuccess]);

  // Get Calendar Events
  useEffect(() => {
    if (isCalendarSuccess && calendarData?.data) {
      const formattedEvents = calendarData.data.data.map((event) => ({
        ...event,
        from: new Date(event.from).toISOString(),
        to: new Date(event.to).toISOString(),
      }));
      setEventsCalender(formattedEvents);
    }
  }, [calendarData, isCalendarSuccess]);

  const handlePageChange2 = (selectedItem) => {
    const selectedPage = selectedItem.selected + 1;
    setPagination((prev) => ({ ...prev, page: selectedPage }));
  };

  const handleCalender = (data) => {
    const { year, month } = data;
  };

  const handlePageChange = async ({ selected }) => {};

  const handleDateChange = (selectedDate, field) => {
    setDate((prev) => {
      const formattedDate = selectedDate ? formatOfDate(selectedDate) : "";
      const newDates = { ...prev, [field]: formattedDate };

      if (
        field === "startDate" &&
        newDates.endDate &&
        formattedDate > newDates.endDate
      ) {
        newDates.endDate = "";
      }

      return newDates;
    });
  };

  // Language Change Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-2">
        {/* Filters */}
        <div className="d-flex flex-wrap gap-2">
          <div className="d-flex flex-grow-1">
            <div className="position-relative w-100">
              <DatePicker
                className="form-control"
                selected={
                  date.startDate
                    ? new Date(moment(date.startDate, "YYYY-MM-DD").toDate())
                    : null
                }
                onChange={(selectedDate) =>
                  handleDateChange(selectedDate, "startDate")
                }
                selectsStart
                startDate={
                  date.startDate
                    ? new Date(moment(date.startDate, "YYYY-MM-DD").toDate())
                    : null
                }
                endDate={date.endDate ? new Date(date.endDate) : null}
                dateFormat="yyyy-MM-dd"
                placeholderText={`${t("select")} ${t("start")} ${t("date")}`}
              />
              <FaCalendarAlt className="calederIcon" />
            </div>
          </div>

          <div className="d-flex flex-grow-1">
            <div className="position-relative w-100">
              <DatePicker
                className="form-control"
                selected={
                  date.endDate
                    ? moment(date.endDate, "YYYY-MM-DD").toDate()
                    : null
                }
                onChange={(selectedDate) =>
                  handleDateChange(selectedDate, "endDate")
                }
                selectsEnd
                startDate={
                  date.startDate
                    ? moment(date.startDate, "YYYY-MM-DD").toDate()
                    : null
                }
                endDate={
                  date.endDate
                    ? moment(date.endDate, "YYYY-MM-DD").toDate()
                    : null
                }
                minDate={
                  date.startDate
                    ? moment(date.startDate, "YYYY-MM-DD").toDate()
                    : new Date()
                }
                dateFormat="yyyy-MM-dd"
                placeholderText={`${t("select")} ${t("end")} ${t("date")}`}
                disabled={!date.startDate}
              />
              <FaCalendarAlt className="calederIcon" />
            </div>
          </div>
        </div>
      </div>

      <ul className="dbTop p-0 d-flex flex-wrap">
        <li className="col-12 col-sm-4">
          <div className="inner" style={{ background: "#FBF7F3" }}>
            <div className="hd d-flex align-items-center mb-3">
              <span>
                <FaUserTie className="icon me-2" />
              </span>
              {t("listed")} {t("drivers")}
            </div>
            <div className="d-flex align-items-center">
              <div className="price">
                <span className="d-block mb-1">
                  {dashboardStats?.listedVendors}
                </span>
              </div>
            </div>
          </div>
        </li>
        <li className="col-12 col-sm-4">
          <div className="inner" style={{ background: "#F8F9FB" }}>
            <div className="hd d-flex align-items-center mb-3">
              <span>
                <FaBus className="icon me-2" />
              </span>{" "}
              {t("registered")} {t("vehicles")}
            </div>
            <div className="d-flex align-items-center">
              <div className="price">
                <span className="d-block mb-1">
                  {dashboardStats?.registeredVehicles}
                </span>
              </div>
            </div>
          </div>
        </li>
        {/* <li className='col-12 col-sm-6 col-lg-3'>
                                <div className='inner' style={{ background: "#FBF7F3" }}>
                                    <div className='hd d-flex align-items-center mb-3'><span><FaRoute className='icon me-2' /></span> Total Routes</div>
                                    <div className='d-flex align-items-center'>
                                        <div className='price'><span className='d-block mb-1'>55</span></div>
                                    </div>
                                </div>
                            </li> */}
        <li className="col-12 col-sm-4">
          {" "}
          <div className="inner" style={{ background: "#F8F9FB" }}>
            <div className="hd d-flex align-items-center mb-3">
              <span>
                <FaUserGraduate className="icon me-2" />
              </span>{" "}
              {t("registered")} {t("students")}
            </div>
            <div className="d-flex align-items-center">
              <div className="price">
                <span className="d-block mb-1">
                  {dashboardStats?.registeredStudents}
                </span>
              </div>
            </div>
          </div>
        </li>
        <li className="col-12 col-sm-4">
          <div className="inner" style={{ background: "#FBF7F3" }}>
            <div className="hd d-flex align-items-center mb-3">
              <span>
                <AiFillDollarCircle className="icon me-2" />
              </span>{" "}
              {t("monthly")} {t("payments")}
            </div>
            <div className="d-flex align-items-center">
              <div className="price">
                <span className="d-block mb-1">
                  ${dashboardStats?.monthly_payments?.toLocaleString() || 0}
                </span>
              </div>
            </div>
          </div>
        </li>
        <li className="col-12 col-sm-4">
          <div className="inner" style={{ background: "#F8F9FB" }}>
            <div className="hd d-flex align-items-center mb-3">
              <span>
                <AiFillDollarCircle className="icon me-2" />
              </span>{" "}
              {t("overdue")} {t("payments")}
            </div>
            <div className="d-flex align-items-center">
              <div className="price">
                <span className="d-block mb-1">
                  ${dashboardStats?.overdue_payments?.toLocaleString() || 0}
                </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div className="pt-4">
        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <div className="dbSubHd mb-2">
            {t("vehicles")} {t("on")} {t("board")}
          </div>
          <div className="mb-2 filterBox">
            <ul className="d-flex flex-wrap align-items-center p-0 transactionsFilter">
              {/* <li><div className='searchBox'><input type='text' className='input' placeholder='Search..' name="search"
                                            value={search}
                                            onChange={handleSearch} /> <Button className='searchBtn'><IoSearchSharp /></Button></div></li> */}
              {/* <li>
                      <select
                        className="smallSelect"
                        onChange={handleChangeStatus}
                      >
                        <option value="">Status</option>
                        <option value="On Route">On Route</option>
                        <option value="Available">Available</option>
                        <option value="Booked">Booked</option>
                      </select>
                    </li> */}
            </ul>
          </div>
        </div>
        <div className="table m-0">
          <table>
            <thead>
              <tr>
                <th>
                  {t("Sr")}.{t("no")}.
                </th>
                <th>
                  {t("company")} {t("name")}
                </th>
                <th>
                  {t("vehicle")} {t("type")}
                </th>
                <th>
                  {t("vehicle")} {t("license")} {t("plate")}
                </th>
                <th>{t("status")}</th>
              </tr>
            </thead>
            <tbody>
              {isDashboardLoading || isDashboardFetching ? (
                <SkeletonLoading MainLength={10} length={5} />
              ) : reservedVehicles?.length > 0 ? (
                reservedVehicles.map((item, i) => (
                  <tr key={i}>
                    <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                    <td className="text-nowrap">{item?.vendor_name}</td>
                    <td className="text-nowrap">{item?.vehicle_type_name}</td>
                    <td className="text-nowrap">{item?.license_number}</td>
                    <td className="text-nowrap">
                      <span
                        className={`status ${item?.vehicle_status || "unavailable"}`}
                      >
                        {item?.vehicle_status === "scheduled"
                          ? "Reserved"
                          : item?.vehicle_status
                            ? item.vehicle_status.charAt(0).toUpperCase() +
                              item.vehicle_status.slice(1)
                            : "N/A"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="text-center">
                  <td colSpan="5">
                    <div>
                      <span>No vehicles found</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <ul className="paging m-0 p-0 pt-3 d-flex">
          <li>
            <ReactPaginate
              pageCount={pagination.totalPages}
              onPageChange={handlePageChange2}
              containerClassName={"paging m-0 p-0 pt-3 d-flex"}
              activeClassName={"active"}
              previousLabel={t("previous")}
              nextLabel={t("next")}
              selectedPage={pagination.page}
            />
          </li>
        </ul>
      </div>
      <div className="mt-4 outerBox">
        <div className="dbSubHd mb-3">
          {t("reservations")} {t("calendar")}
        </div>
        <div className="calenderBox">
          <Calendar
            onChange={handleCalender}
            events={eventsCalender}
            onClickEvent={(data) => {
              setShow3(true);
              setBookingIdData(data);
            }}
          />
        </div>
      </div>

      <Modal
        className="addbankDetails"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Button className="closePopup" onClick={handleClose3}>
          <IoCloseSharp />
        </Button>
        <ReservationDetail
          bookingIdData={bookingIdData}
          onClose={handleClose3}
        />
      </Modal>
    </>
  );
};
export default SchoolDashboard;
